import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import config from "../../config";
import Icon from "../Icon";
import { withUserMenu } from "../UserMenu";
import { Package as OldPackage } from "./OldPackage"; // components

import Title from "./components/Title";
import Price from "./components/Price";
import styles from "./Package.module.scss"; // globals

var TYPES = config.get("propertyTypes"),
    NB_SLUG = config.get("api.neighbourhood"),
    LinkConverter = function LinkConverter(a) {
  var b = a.to,
      c = _objectWithoutProperties(a, ["to"]),
      d = window.location.pathname === config.routes.get("property.search"),
      e = d ? "a" : Link;

  return d ? /*#__PURE__*/React.createElement(e, Object.assign({
    href: b
  }, c)) : /*#__PURE__*/React.createElement(e, Object.assign({
    to: b
  }, c));
};

export var PackageComponent = function PackageComponent(a) {
  var b = a.data,
      c = a.propertyToCompare,
      d = a.summary,
      e = a.onClick,
      f = a.className,
      g = _defineProperty({}, styles.summary, d);

  if (d) {
    var h = b.name,
        i = b.image,
        j = b.price,
        k = b.promoted,
        l = b.release_name,
        m = l.replace(" Release", ""),
        n = "land" === b.propertyType,
        o = TYPES[b.propertyType],
        p = n ? config.routes.get("landforsale.masterplan", NB_SLUG ? b.release_slug : "".concat(b.neighbourhood_slug, "/").concat(b.release_slug), "lot", b.slug) : config.routes.get("houseandland", b.slug),
        q = config.routes.get("property.results");
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.package, g, f)
    }, b.unavailable ? /*#__PURE__*/React.createElement("div", {
      className: styles.unavailable
    }) : null, /*#__PURE__*/React.createElement(LinkConverter, {
      to: p,
      alt: "",
      onClick: e
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.header, "ta-row")
    }, b.unavailable ? /*#__PURE__*/React.createElement("div", {
      className: styles.flag
    }, "unavailable") : null, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundImage: "url(".concat(i && i.url ? i.url : i, ")")
      },
      className: styles.image
    }), /*#__PURE__*/React.createElement(Title, {
      header: o,
      text: h,
      secondaryText: m,
      className: styles.title,
      small: !0
    })), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.specs, "ta-row")
    }, /*#__PURE__*/React.createElement(Price, {
      number: j,
      promoted: !n && k
    }), /*#__PURE__*/React.createElement("span", {
      className: "package--amenities"
    }, n ? /*#__PURE__*/React.createElement(React.Fragment, null, b.frontage && /*#__PURE__*/React.createElement("div", {
      className: styles.frontage
    }, /*#__PURE__*/React.createElement("b", null, "Frontage:"), " ", b.frontage, "m\xB2"), b.area && /*#__PURE__*/React.createElement("div", {
      className: styles.land_size
    }, /*#__PURE__*/React.createElement("b", null, "Land size:"), " ", b.area, "m")) : /*#__PURE__*/React.createElement(React.Fragment, null, b.bedrooms && /*#__PURE__*/React.createElement("span", null, b.bedrooms, " ", /*#__PURE__*/React.createElement(Icon, {
      icon: "bedroom"
    })), b.bathrooms && /*#__PURE__*/React.createElement("span", null, b.bathrooms, " ", /*#__PURE__*/React.createElement(Icon, {
      icon: "bathroom"
    })), b.living && /*#__PURE__*/React.createElement("span", null, b.living, " ", /*#__PURE__*/React.createElement(Icon, {
      icon: "living"
    })), b && 0 !== b.garage && /*#__PURE__*/React.createElement("span", null, b.garage, " ", /*#__PURE__*/React.createElement(Icon, {
      icon: "garage"
    })))))), !(void 0 !== c) || c ? /*#__PURE__*/React.createElement("div", {
      className: "ta-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.actionButton
    }, b.view_count ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: styles.emphasize
    }, 100 < b.view_count ? "100+" : b.view_count), "Others interested") : /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0")), n ? /*#__PURE__*/React.createElement("div", {
      className: styles.actionButton
    }) : /*#__PURE__*/React.createElement(LinkConverter, {
      to: "".concat(q, "?similar_properties=").concat(b.slug),
      className: styles.actionButton,
      onClick: e
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.emphasize
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "house"
    })), "Similar properties")) : null);
  }

  return /*#__PURE__*/React.createElement(OldPackage, a);
};
export var Package = function Package(a) {
  return withUserMenu(PackageComponent)(a);
};
export default Package;